export default __webpack_public_path__ + "static/smartWorkflowImg5-28be9e70be41d4651d64b59f1704bcb9.png";